// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const AlipayIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'alipay'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M12 2C17.523 2 22 6.477 22 12C22.0035 13.9203 21.4513 15.8006 20.41 17.414C20.3795 17.4813 20.3416 17.545 20.297 17.604L20.225 17.689C19.3055 19.0198 18.0765 20.1074 16.6438 20.8583C15.2112 21.6092 13.6175 22.001 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM17.984 6.695C16.9071 5.48135 15.4867 4.62383 13.9111 4.23622C12.3356 3.84861 10.6794 3.94923 9.16242 4.52474C7.64539 5.10024 6.33922 6.12342 5.41721 7.4585C4.49519 8.79359 4.00093 10.3775 4 12C3.99989 13.6153 4.48876 15.1928 5.40229 16.525C6.31582 17.8571 7.61122 18.8815 9.11807 19.4634C10.6249 20.0453 12.2726 20.1574 13.8444 19.785C15.4162 19.4126 16.8384 18.5731 17.924 17.377L16.257 16.598L14.517 15.782L13.698 15.406C13.4191 15.8017 13.1088 16.1742 12.77 16.52C11.648 17.641 10.52 18 9.49999 18C7.632 18 6 16.82 6 15C6 13.316 7.48 12 8.99999 12C10.267 12 11.494 12.334 12.887 12.884C13.043 12.5827 13.191 12.277 13.331 11.967L13.534 11.5H8.99999C8.74511 11.4997 8.49996 11.4021 8.31463 11.2272C8.12929 11.0522 8.01776 10.813 8.00282 10.5586C7.98789 10.3042 8.07067 10.0536 8.23426 9.85817C8.39785 9.66271 8.6299 9.5371 8.88299 9.507L8.99999 9.5H11V9H8C7.74512 8.99972 7.49996 8.90212 7.31463 8.72715C7.12929 8.55218 7.01776 8.31305 7.00282 8.0586C6.98789 7.80416 7.07067 7.55362 7.23426 7.35817C7.39785 7.16271 7.6299 7.0371 7.883 7.007L8 7H11V6C11.0003 5.74512 11.0979 5.49997 11.2728 5.31463C11.4478 5.1293 11.6869 5.01776 11.9414 5.00283C12.1958 4.98789 12.4464 5.07067 12.6418 5.23426C12.8373 5.39785 12.9629 5.6299 12.993 5.883L13 6V7H16C16.2549 7.00028 16.5 7.09788 16.6854 7.27285C16.8707 7.44782 16.9822 7.68695 16.9972 7.94139C17.0121 8.19584 16.9293 8.44638 16.7657 8.64183C16.6021 8.83728 16.3701 8.9629 16.117 8.993L16 9H13V9.5H15C15.1607 9.50011 15.319 9.53895 15.4615 9.61323C15.604 9.6875 15.7265 9.79503 15.8186 9.9267C15.9108 10.0584 15.9698 10.2103 15.9908 10.3696C16.0117 10.529 15.9939 10.691 15.939 10.842C15.5944 11.811 15.1903 12.7578 14.729 13.677L15.51 14.037L18.6 15.486L19.089 15.712C19.8409 14.2743 20.1379 12.6419 19.9405 11.0314C19.7432 9.421 19.0608 7.90863 17.984 6.695ZM8.99999 14C8.51999 14 8 14.484 8 15C8 15.38 8.36799 16 9.49999 16L9.69999 15.991C10.148 15.951 10.702 15.759 11.355 15.105C11.5114 14.9476 11.659 14.7817 11.797 14.608C10.687 14.194 9.82699 14 8.99999 14Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
AlipayIcon.displayName = 'AlipayIcon'
export { AlipayIcon }
